import { useEffect, useRef } from 'react';

import { BRIDGE_KEYS, LayerDataBridge } from '../../../../shared/utils/layer-data-bridge';
import { useAuth } from '../../../../app/providers/AuthContext';
import { useLayerManager } from '../../../../shared/hooks/use-layer-manager';
import { useMyVwContext } from '../../../../shared/hooks/use-my-vw-context';
import { useTrackingManager } from '../../../../shared/hooks/use-tracking-manager';
import { ShimBackgroundTypeV2 } from '@volkswagen-onehub/layer-manager';

export type EmailLayerData = {
  translationHandler: (key: string) => string;
  trackingManager: any;
  logout: () => void;
  onClose: () => void;
};

type EmailLayerRenderFn = (
  state: { dataBridge: LayerDataBridge<EmailLayerData> },
  close: any,
) => JSX.Element;

export const useEmailLayer = (
  active: boolean,
  onClose: () => void,
  renderFn: EmailLayerRenderFn,
): void => {
  const layerManager = useLayerManager();
  const hasOpenedRef = useRef(false);
  const layerHandleRef = useRef<{ close: () => void } | null>(null);
  const { translationHandler } = useMyVwContext();
  const { logout } = useAuth();
  const trackingManager = useTrackingManager();

  useEffect(() => {
    if (active && !hasOpenedRef.current && layerManager) {
      hasOpenedRef.current = true;
      const bridge = LayerDataBridge.getInstance<EmailLayerData>(BRIDGE_KEYS.FOCUS_EMAIL);
      bridge.setData({
        translationHandler,
        trackingManager,
        logout,
        onClose: () => {
          hasOpenedRef.current = false;
          bridge.setData(null);
          layerHandleRef.current?.close();
          onClose();
        },
      });
      layerHandleRef.current = layerManager.openFocusLayer(
        renderFn, 
        { dataBridge: bridge }, 
        { 
          size: 'A' as any, 
          shimBackgroundType: ShimBackgroundTypeV2.OPAQUE 
        } ) ?? null;
    }
  }, [active]);

};
